<script setup>
import ActionButton from '@/components/shared/buttons/ActionButton.vue'

//Emits and props
defineEmits([
  'click',
])
</script>

<template>
  <ActionButton
    icon="chevron_left"
    v-bind="$attrs"
    type="secondary"
    aria-label="Go back"
    @click="$emit('click', $event)"
  />
</template>
